import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

import SEO from 'components/SEO/SEO';
import { useDavidApi } from 'utility/DavidApi/DavidApi';
import Container from 'components/Grid/Container';
import DataTable from "../components/Table/DataTable";
import TableModal from "../components/Table/TableModal";
import useModal from "../components/Modal/useModal";
import Button from "../components/Button/Button";
import ReviewCutForm from "../components/Form/ReviewCutForm";
import { isAdmin } from "../utility/Authorization/roleUtils";
import DeleteProjectForm from 'components/Form/DeleteProjectForm';

const columns = [
    // {
    //     name: "id",
    //     label: "ID",
    //     options: {
    //         filter: true,
    //         sort: true,
    //     }
    // },
    {
        name: "client",
        label: "Client",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "address",
        label: "Street Number",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "street",
        label: "Street",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "zipcode",
        label: "Zipcode",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "actual",
        label: "Actual",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "actions",
        label: "Actions",
        options: {
            filter: false,
            sort: false,
        }
    },
];

function Review() {
    const api = useDavidApi();
    const reviewCutsParameters = {
        exists: {
            reviewed: false
        },
        incomplete: false
    };
    const [loading, setLoading] = useState(true);
    const reviewCutModal = useModal();
    const [approveCutModal, setApproveCutModal] = useState(null);
    const deleteProjectModal = useModal();
    const [deleteProjectModalClient, setDeleteProjectModalClient] = useState(null);

    const deleteProjectModalTriggerHandler = (id) => {
        setDeleteProjectModalClient(id);
        deleteProjectModal.show();
    }

    const refreshCuts = () => {
        (async () => {
            setLoading(true);
            api.getCuts(reviewCutsParameters);
        })();
    }


    useEffect(() => {
        setLoading(true);
        api.getCuts(reviewCutsParameters);
    }, []);

    useEffect(() => {
        if (api.cuts === null) {
            return;
        }
        setLoading(false);
        reviewCutModal.hide();
    }, [api.cuts]);

    const approveCutModalTriggerHandler = (cut) => {
        setApproveCutModal(cut);
        reviewCutModal.show();
    }

    const getTableRowDataForCuts = (cut) => {
        let actualMeasurements = '';
        let actualLenth = '';
        let actualWidth = '';
        let actualDepth = '';

        if (cut?.actualLength) {
            actualLenth = cut.actualLength;
            actualMeasurements = cut.actualLength + 'L x ' + cut.actualWidth + 'W x ' + cut.actualDepth + 'D';
        } else {
            actualLenth = '0';
        }

        if (cut?.actualWidth) {
            actualWidth = cut.actualWidth;
        } else {
            actualWidth = '0';
        }

        if (cut?.actualDepth) {
            actualDepth = cut.actualDepth;
        } else {
            actualDepth = '0';
        }

        let cutTableRowData = {
            ...cut,
            ...{
                client: cut?.project?.client?.name,
                actual: actualMeasurements,
                actions: (
                    <div className="table-row-actions-container">
                        <Button
                            size={'sm'}
                            iconLeft={<FontAwesomeIcon icon={solid('edit')} />}
                            to={"/projects/" + cut?.project?.id + "/edit"}
                            target="_blank"
                        >
                            Edit
                        </Button>
                        <Button
                            size={'sm'}
                            iconLeft={<FontAwesomeIcon icon={solid('trash')} />}
                            onClick={() => deleteProjectModalTriggerHandler(cut?.project?.id)}
                            variant="red"
                        >
                            Delete
                        </Button>
                        <Button
                            size={'sm'}
                            iconLeft={<FontAwesomeIcon icon={solid('square-check')} />}
                            onClick={() => approveCutModalTriggerHandler(cut)}
                        >
                            Approve
                        </Button>
                    </div>
                )
            }
        };

        return cutTableRowData;
    }

    return (  
        <>
            <SEO title="Review" />
            {isAdmin(api.profile) ? (
                <Container vpadding={30}>
                    <h1>Review Cuts</h1>
                    <div>
                        <DataTable
                            columns={columns}
                            data={Array.isArray(api?.cuts) ? api?.cuts?.map((cut) => getTableRowDataForCuts(cut)) : []}
                            loading={loading}
                            options={{
                                sortOrder: {
                                    name: 'name',
                                    direction: 'asc',
                                },
                            }}
                        />
                        <TableModal title="Approve Cut" isShowing={reviewCutModal.isShowing} hide={reviewCutModal.hide}>
                            <ReviewCutForm
                                cut={approveCutModal}
                                hideModal={reviewCutModal.hide}
                                reviewCutsParameters={reviewCutsParameters}
                            />
                        </TableModal>

                        <TableModal title="Delete Project" isShowing={deleteProjectModal.isShowing} hide={deleteProjectModal.hide}>
                            <DeleteProjectForm
                                id={deleteProjectModalClient}
                                hideModal={deleteProjectModal.hide}
                                onDelete={refreshCuts}
                            />
                        </TableModal>
                    </div>
                </Container>
            ) : (
                <Container vpadding={30}>
                    <h1><FontAwesomeIcon icon={solid('triangle-exclamation')} /></h1>
                    <h4>This page is only viewable by admins.</h4>
                </Container>
            )};
        </>   
    )
}

export default Review;
